import { render, staticRenderFns } from "./ComponentFirstFMDEditor.vue?vue&type=template&id=648a341d&scoped=true&"
import script from "./ComponentFirstFMDEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentFirstFMDEditor.vue?vue&type=script&lang=js&"
import style0 from "./ComponentFirstFMDEditor.vue?vue&type=style&index=0&id=648a341d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a341d",
  null
  
)

export default component.exports